export default "__VITE_ASSET__XL$vU4PU__"